import React, { useState } from 'react'
import NewActionMenu from 'components/ContentBox/Global/ActionMenu/ActionMenu'
import styles from './RowCompany.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'

const RowCompany = ({ company, index, action }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const menu = [
    { name: 'Edit', action: 'edit' },
    { name: 'Delete', action: 'delete' },
  ]

  const currency = company.currency
    ? `${company.currency.name} (${company.currency.short_name} ${company.currency.sign})`
    : 'Не указано'

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''} ${expanded && styles.colorBgActive}`}
      >
        <div className={styles.containerInf}>
          <div
            className={`${styles.infStyl} ${styles.name} ${expanded ? styles.expClr : styles.notExpClr}`}
          >
            {company.name}
          </div>
          <div className={styles.buttons}>
            <NewActionMenu variant='simple' onSimpleAction={toggleExpand} />
            <ActionMenu menu={menu} action={action} items={company} />
          </div>
        </div>
      </div>
      {expanded && (
        <div className={styles.clientDetails}>
          <div>
            <div className={`${styles.formField}`}>
              <div className={styles.label}>Currency:</div>
              <div className={styles.info}>{currency}</div>
            </div>
            <div className={`${styles.formField}`}>
              <div className={styles.label}>Comment:</div>
              <div className={styles.info}>
                {company.comment ? company.comment : 'Не указано'}
              </div>
            </div>
          </div>
          <div>
            <div className={`${styles.formField}`}>
              <div className={styles.label}>Assessment type:</div>
              <div className={styles.info}>{company?.mark_name}</div>
            </div>
            <div className={`${styles.formField}`}>
              <div className={styles.label}>Cashback:</div>
              <div className={styles.info}>
                {company?.active_cashback ? 'Activated' : 'Deactivated'}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default RowCompany
